import { ActionType } from '../../abacus/enums/action-type.enum'
import { LinkType } from '../../abacus/enums/link-type.enum'
import { ResourceDefinition } from '../../abacus/interfaces/resource-definition.interface'

export const intergovernmentalOrganisationDefinition: ResourceDefinition = {
  title: 'Intergovernmental Organisations',
  nameSingular: 'Membership in intergovernmental or supranational organisation',
  namePlural: 'Intergovernmental Organisations',
  className: 'IntergovernmentalOrganisation',
  mainIdentifier: 'name',
  slug: 'intergovernmental-organisations',
  path: 'intergovernmental-organisations',
  icon: 'icon-tag',
  hasDetailPage: false,
  hasListPage: true,
  buttons: [LinkType.CREATE],
  defaultLink: LinkType.EDIT,
  childrenThatPreventDelete: [],
  dropdownLinks: [
    {
      label: 'Edit',
      permission: 'editPolicyInitiativeTaxonomies',
      action: (intergovernmentalOrganisation) => ({
        type: ActionType.Link,
        link: {
          path: `${intergovernmentalOrganisationDefinition.path}/${intergovernmentalOrganisation.id}/edit`
        }
      })
    },
    {
      label: 'Delete',
      permission: 'deletePolicyInitiativeTaxonomies',
      action: (intergovernmentalOrganisation) => ({
        type: ActionType.Delete,
        delete: {
          itemToDelete: intergovernmentalOrganisation,
          definition: intergovernmentalOrganisationDefinition
        }
      })
    }
  ]
}
